(function () {
  if (window.ClozsWishlistV2) return;
  window.ClozsWishlistV2 = true;

  var storageKey = 'clozs:wishlist:v1';
  var rootPath = (window.routes && window.routes.root_url ? window.routes.root_url : '/').replace(/\/$/, '');
  var productCache = Object.create(null);
  var productRequests = Object.create(null);
  var lastRenderSignature = '';

  function buildItemKey(handle, variantId) {
    return String(handle || '') + '::' + String(variantId || '');
  }

  function readItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(parsed)) return [];
      var seen = {};
      return parsed.filter(function (item) {
        if (!item || !item.handle) return false;
        item.key = item.key || buildItemKey(item.handle, item.variantId || item.variant_id || item.id);
        if (seen[item.key]) return false;
        seen[item.key] = true;
        return true;
      });
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character];
    });
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, window.shopSettings && window.shopSettings.moneyFormat);
    }
    return 'LE ' + (value / 100).toFixed(2);
  }

  function buildProductUrl(item) {
    var url = item.url || ((rootPath || '') + '/products/' + item.handle);
    if (!item.variantId) return url;
    try {
      var parsedUrl = new URL(url, window.location.origin);
      parsedUrl.searchParams.set('variant', item.variantId);
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      return url;
    }
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (productRequests[handle]) return productRequests[handle];

    productRequests[handle] = window.fetch((rootPath || '') + '/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (product) {
      if (product) productCache[handle] = product;
      delete productRequests[handle];
      return product;
    }).catch(function () {
      delete productRequests[handle];
      return null;
    });

    return productRequests[handle];
  }

  function getVariant(product, item) {
    if (!product || !Array.isArray(product.variants) || !item.variantId) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(item.variantId);
    }) || null;
  }

  function getButtonVariantId(button) {
    return button.getAttribute('data-product-variant-id') || button.getAttribute('data-variant-id') || '';
  }

  function getButtonVariantTitle(button) {
    return button.getAttribute('data-product-variant-title') || '';
  }

  function getButtonKey(button) {
    return buildItemKey(button.getAttribute('data-product-handle'), getButtonVariantId(button));
  }

  function getContext(button) {
    return button.closest('.card-wrapper, .card, .product, .product__info-container, [id^="ProductInfo-"]') || document;
  }

  function getButtonImage(button) {
    var direct = button.getAttribute('data-product-image');
    if (direct) return direct;

    var context = getContext(button);
    var image = context.querySelector('img[src]:not([role="presentation"])');
    if (!image && context !== document) {
      image = document.querySelector('.product__media img[src], .product__media-wrapper img[src], [data-media-id] img[src]');
    }
    return image ? (image.currentSrc || image.src || '') : '';
  }

  function getButtonPriceText(button) {
    var direct = button.getAttribute('data-product-price-text');
    if (direct) return direct;

    var context = getContext(button);
    var price = context.querySelector('.price__sale .price-item--sale, .price-item--sale:not(.price-item--regular), .price-item--regular, .price .money');
    if (!price && context !== document) {
      price = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular, .product__info-container .price-item--sale, .product__info-container .price-item--regular');
    }
    return price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getButtonPrice(button) {
    var raw = button.getAttribute('data-product-price');
    return raw && !isNaN(Number(raw)) ? Number(raw) : null;
  }

  function setButtonState(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    var strings = window.wishlistStrings || {};
    var label = isActive ? (strings.added || 'Saved') : (strings.add || 'Save');
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    var text = button.querySelector('[data-wishlist-toggle-label]');
    if (text) text.textContent = label;
  }

  function updateToggleButtons(items) {
    var keys = items.map(function (item) { return item.key || buildItemKey(item.handle, item.variantId); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      setButtonState(button, keys.indexOf(getButtonKey(button)) > -1);
    });
  }

  function updateCount(items) {
    var count = items.length;
    var strings = window.wishlistStrings || {};
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
    document.querySelectorAll('[data-wishlist-count-label]').forEach(function (node) {
      var template = strings.savedCount || '[count] saved';
      node.textContent = template.replace('[count]', String(count));
    });
  }

  function itemSignature(items) {
    return items.map(function (item) {
      return item.key || buildItemKey(item.handle, item.variantId);
    }).join('|');
  }

  function getStoredPriceText(item) {
    if (item.priceText) return item.priceText;
    if (item.price != null && item.price !== '') return formatMoney(item.price);
    return '';
  }

  function buildCardMarkup(item, index) {
    var strings = window.wishlistStrings || {};
    var productUrl = buildProductUrl(item);
    var title = item.title || item.handle || '';
    var variantTitle = item.variantTitle || '';
    var priceText = getStoredPriceText(item);
    var image = item.image || '';
    var viewLabel = escapeHtml(strings.viewProduct || 'View product');
    var removeLabel = escapeHtml(strings.remove || 'Remove');
    var soldOutLabel = escapeHtml((window.variantStrings && window.variantStrings.soldOut) || 'Sold out');
    var availabilityMarkup = item.available === false ? '<span class="clozs-wishlist-card__badge">' + soldOutLabel + '</span>' : '';
    var imageMarkup = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="' + (index === 0 ? 'eager' : 'lazy') + '" decoding="async">'
      : '<span class="clozs-wishlist-card__placeholder" aria-hidden="true">' + escapeHtml((title || 'S').charAt(0)) + '</span>';
    var key = escapeHtml(item.key || buildItemKey(item.handle, item.variantId));

    return '<article class="clozs-wishlist-card aligan-wishlist-card" data-fp-native-wishlist="1" data-wishlist-key="' + key + '">' +
      '<a class="clozs-wishlist-card__media aligan-wishlist-media" href="' + escapeHtml(productUrl) + '">' + imageMarkup + availabilityMarkup + '</a>' +
      '<div class="clozs-wishlist-card__body aligan-wishlist-content">' +
        '<a class="clozs-wishlist-card__title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(title) + '</a>' +
        (variantTitle ? '<div class="clozs-wishlist-card__variant">' + escapeHtml(variantTitle) + '</div>' : '') +
        '<div class="clozs-wishlist-card__price"' + (priceText ? '' : ' hidden') + '>' + escapeHtml(priceText) + '</div>' +
        '<div class="clozs-wishlist-card__actions">' +
          '<a class="clozs-wishlist-card__view" href="' + escapeHtml(productUrl) + '">' + viewLabel + '<span class="visually-hidden" data-fp-search-marker="view"> view product </span></a>' +
          '<button type="button" class="clozs-wishlist-card__remove" data-wishlist-remove="' + key + '" aria-label="' + removeLabel + ' ' + escapeHtml(title) + '">' + removeLabel + '<span class="visually-hidden" data-fp-search-marker="remove"> remove </span></button>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function updateCardFromItem(item) {
    var key = item.key || buildItemKey(item.handle, item.variantId);
    var card = document.querySelector('[data-wishlist-items] [data-wishlist-key="' + CSS.escape(key) + '"]');
    if (!card) return;

    var title = card.querySelector('.clozs-wishlist-card__title');
    if (title && item.title) title.textContent = item.title;

    var media = card.querySelector('.clozs-wishlist-card__media');
    if (media && item.image) {
      var image = media.querySelector('img');
      if (!image) {
        var placeholder = media.querySelector('.clozs-wishlist-card__placeholder');
        if (placeholder) placeholder.remove();
        image = document.createElement('img');
        image.loading = 'eager';
        image.decoding = 'async';
        media.insertBefore(image, media.firstChild);
      }
      if (image.src !== item.image) image.src = item.image;
      image.alt = item.title || '';
    }

    var price = card.querySelector('.clozs-wishlist-card__price');
    var priceText = getStoredPriceText(item);
    if (price && priceText) {
      price.hidden = false;
      price.textContent = priceText;
    }
  }

  function persistEnrichedItem(enriched) {
    var items = readItems();
    var changed = false;
    items = items.map(function (item) {
      var key = item.key || buildItemKey(item.handle, item.variantId);
      if (key !== enriched.key) return item;
      ['title','variantTitle','image','price','available'].forEach(function (field) {
        if (enriched[field] !== undefined && enriched[field] !== null && enriched[field] !== '' && item[field] !== enriched[field]) {
          item[field] = enriched[field];
          changed = true;
        }
      });
      return item;
    });
    if (changed) writeItems(items);
  }

  function hydrateItem(item) {
    if (!item || !item.handle) return;
    fetchProduct(item.handle).then(function (product) {
      if (!product) return;
      var variant = getVariant(product, item);
      var image = variant && variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : (product.featured_image || item.image || '');
      var enriched = {
        key: item.key || buildItemKey(item.handle, item.variantId),
        title: product.title || item.title || '',
        variantTitle: item.variantTitle || (variant && variant.title && variant.title !== 'Default Title' ? variant.title : ''),
        image: image,
        price: variant && typeof variant.price !== 'undefined' ? variant.price : product.price,
        available: variant ? variant.available !== false : product.available !== false
      };
      persistEnrichedItem(enriched);
      updateCardFromItem(enriched);
      document.dispatchEvent(new CustomEvent('wishlist:hydrated', { detail: { key: enriched.key } }));
    });
  }

  function hydrateItems(items) {
    var run = function () {
      items.forEach(hydrateItem);
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 350 });
    } else {
      window.setTimeout(run, 20);
    }
  }

  function renderItems(items, force) {
    var shell = document.querySelector('[data-wishlist-shell]');
    if (!shell) return;
    var list = shell.querySelector('[data-wishlist-items]');
    var empty = shell.querySelector('[data-wishlist-empty]');
    if (!list || !empty) return;

    if (!items.length) {
      if (list.innerHTML) list.innerHTML = '';
      empty.hidden = false;
      list.hidden = true;
      lastRenderSignature = '';
      list.removeAttribute('data-wishlist-render-signature');
      document.dispatchEvent(new CustomEvent('wishlist:rendered'));
      return;
    }

    empty.hidden = true;
    list.hidden = false;
    var signature = itemSignature(items);
    var currentSignature = list.getAttribute('data-wishlist-render-signature') || '';

    if (force || signature !== lastRenderSignature || signature !== currentSignature || !list.children.length) {
      list.innerHTML = items.map(buildCardMarkup).join('');
      list.setAttribute('data-wishlist-render-signature', signature);
      lastRenderSignature = signature;
      document.dispatchEvent(new CustomEvent('wishlist:rendered'));
    }

    hydrateItems(items);
  }

  function sync(force) {
    var items = readItems();
    writeItems(items);
    updateToggleButtons(items);
    updateCount(items);
    renderItems(items, force === true);
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  function addItem(button) {
    var items = readItems();
    var handle = button.getAttribute('data-product-handle');
    var variantId = getButtonVariantId(button);
    var key = buildItemKey(handle, variantId);
    if (!handle || items.some(function (item) { return (item.key || buildItemKey(item.handle, item.variantId)) === key; })) return;

    var price = getButtonPrice(button);
    items.unshift({
      key: key,
      handle: handle,
      variantId: variantId,
      variantTitle: getButtonVariantTitle(button),
      url: button.getAttribute('data-product-url'),
      title: button.getAttribute('data-product-title') || '',
      image: getButtonImage(button),
      price: price,
      priceText: getButtonPriceText(button)
    });

    writeItems(items);
    sync(true);
  }

  function removeItem(key) {
    var items = readItems().filter(function (item) {
      return (item.key || buildItemKey(item.handle, item.variantId)) !== key && item.handle !== key;
    });
    writeItems(items);
    sync(true);
  }

  function toggleItem(button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    var items = readItems();
    var key = getButtonKey(button);
    var exists = items.some(function (item) { return (item.key || buildItemKey(item.handle, item.variantId)) === key; });
    if (exists) removeItem(key); else addItem(button);
  }

  function openDrawer() {
    var shell = document.querySelector('[data-wishlist-shell]');
    var drawer = document.getElementById('clozs-wishlist-drawer');
    if (!shell || !drawer) return;

    shell.hidden = false;
    document.body.classList.add('clozs-wishlist-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-wishlist-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    sync(false);
    window.requestAnimationFrame(function () { drawer.focus(); });
  }

  function closeDrawer() {
    var shell = document.querySelector('[data-wishlist-shell]');
    var drawer = document.getElementById('clozs-wishlist-drawer');
    if (!shell || !drawer) return;
    shell.hidden = true;
    document.body.classList.remove('clozs-wishlist-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-wishlist-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) { event.preventDefault(); openDrawer(); return; }
    var closeButton = event.target.closest('[data-wishlist-close]');
    if (closeButton) { event.preventDefault(); closeDrawer(); return; }
    var toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) { event.preventDefault(); toggleItem(toggleButton); return; }
    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) { event.preventDefault(); removeItem(removeButton.getAttribute('data-wishlist-remove')); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) sync(true);
  });

  window.ClozsWishlist = { sync: sync, open: openDrawer, close: closeDrawer };

  var boot = function () { sync(true); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
